<script lang="ts" setup>
import { computed } from 'vue'
import {
	ButtonOutlineTheme,
	ButtonSize,
	RippleTheme,
} from '@/types/ButtonLegacy'
import BsRipple from '@/legacy/components/Ripple.vue'

const props = defineProps({
	text: {
		type: String,
		required: true,
	},
	action: {
		type: Function,
	},
	theme: {
		type: String,
		default: ButtonOutlineTheme.Normal,
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	isRoundEdge: {
		type: Boolean,
		default: false,
	},
	size: {
		type: String,
		default: ButtonSize.Medium,
	},
	isFullWidth: {
		type: Boolean,
		default: false,
	},
})

const rippleTheme = computed(() => {
	return RippleTheme.Dark
})
const isShowRipple = computed(() => {
	return (
		!props.isDisabled &&
		props.theme !== ButtonOutlineTheme.Social &&
		props.theme !== ButtonOutlineTheme.Revamp
	)
})

function onClick() {
	if (props.isDisabled || props.action === undefined) {
		return
	}

	props.action()
}
</script>

<template>
	<a
		href="javascript:void(0)"
		class="bs-button-outline"
		:class="[
			{ 'bs-button-outline--disabled': isDisabled },
			{ 'bs-button-outline--round--edge': isRoundEdge },
			`bs-button-outline__size--${size}`,
			theme && `bs-button-outline--${theme}`,
			{ 'bs-button-outline--is-full-width': isFullWidth },
		]"
		@click.stop="onClick"
	>
		<BsRipple v-if="isShowRipple" :theme="rippleTheme" />
		<span class="bs-button-outline__leading" v-if="$slots.leading">
			<slot name="leading"></slot>
		</span>
		<span class="bs-button-outline__text">{{ text }}</span>
		<span class="bs-button-outline__trailing" v-if="$slots.trailing">
			<slot name="trailing"></slot>
		</span>
	</a>
</template>
